import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Croquis } from 'app/models/croquis.model';


@Injectable({
  providedIn: 'root'
})
export class CroquisService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'croquis';

  hasComponentBeenViewed: boolean = false;

  constructor(private http: HttpClient) { }

  getCroquis(etage_id: number): Observable<Croquis>{
    return this.http.get<Croquis>(this.API_URL + this.MODEL_URL + '/' + etage_id).pipe(
        catchError(err => throwError(err))
    );
  }

  store(croquis: Croquis): Observable<Croquis> {
    return this.http.post<Croquis>(this.API_URL + this.MODEL_URL, croquis).pipe(
      catchError(err => throwError(err))
    );
  }

  getSVGParEtage(etage_id: number): Observable<string>{
    return this.http.get<string>(this.API_URL + this.MODEL_URL + '/get_svg/' + etage_id).pipe(
        catchError(err => throwError(err))
    );
  }

}
